module.exports = __webpack_public_path__ + "static/img/39.7e5c9596.png";